import { useEffect, useState } from 'react';
import { Alert, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import TestsApi from '../../api/TestsApi';

interface GoalSetupChecksProps {
  selectedMemberWebsite: string;
  funnelId: string | number;
  // Campaign goal settings: only warn about the webhooks picked there.
  onlyWebhookIds?: string[];
  // Changes when the funnel's pages change, so the check runs again.
  refreshKey?: string;
  mt?: number;
}

interface SetupIssue {
  id: string;
  message: string;
}

/* Setup check for a funnel's goals (funnel and campaign goal settings): a
   "Count as Purchase" webhook that has never sent a sale. Shows nothing when
   all is well. */
export function GoalSetupChecks({ selectedMemberWebsite, funnelId, onlyWebhookIds, refreshKey = '', mt = 10 }: GoalSetupChecksProps) {
  const [webhooks, setWebhooks] = useState<SetupIssue[]>([]);

  useEffect(() => {
    if (!selectedMemberWebsite || !funnelId) {
      setWebhooks([]);
      return;
    }
    let active = true;
    TestsApi.getgoalsetupchecks({ system_website_id: selectedMemberWebsite, funnel_id: funnelId })
      .then((response: any) => (response.ok ? response.json() : null))
      .then((data: any) => {
        if (!active || !data || data.status !== 1) return;
        setWebhooks((data.data.webhooks || []).map((w: any) => ({
          id: w.webhook_id,
          message: `We haven't received any sales from “${w.name}” yet. Check your webhook setup.`,
        })));
      })
      .catch(() => null);
    return () => { active = false; };
  }, [selectedMemberWebsite, funnelId, refreshKey]);

  const shown = webhooks.filter((w) => !onlyWebhookIds || onlyWebhookIds.includes(w.id));
  if (!shown.length) return null;
  return (
    <Alert icon={<IconAlertCircle size={16} />} color="yellow" mt={mt}>
      {shown.map((issue) => <Text key={issue.id} size="sm">{issue.message}</Text>)}
    </Alert>
  );
}
